import { render, staticRenderFns } from "./EmailModal.vue?vue&type=template&id=393a86c8&scoped=true&"
import script from "./EmailModal.vue?vue&type=script&lang=ts&"
export * from "./EmailModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393a86c8",
  null
  
)

export default component.exports